module.exports = __webpack_public_path__ + "img/back.63ac45e9.svg";